import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Header, Footer, FloatingWhatsApp } from "./components/Layout";
import { ChatAssistant } from "./components/ChatAssistant";
import { ContentProvider } from "./context/ContentContext";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Education from "./pages/Education";
import Insights from "./pages/Insights";
import Article from "./pages/Article";
import Career from "./pages/Career";
import Internship from "./pages/Internship";
import Contact from "./pages/Contact";
import Founder from "./pages/Founder";
import Privacy from "./pages/Privacy";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import ContentEditor from "./pages/admin/ContentEditor";
import TeamServices from "./pages/admin/TeamServices";
import Submissions from "./pages/admin/Submissions";
import Media from "./pages/admin/Media";
import Settings from "./pages/admin/Settings";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/consulting" element={<Services />} />
        <Route path="/wellness" element={<Services />} />
        <Route path="/ventures" element={<Services />} />
        <Route path="/corporate" element={<Services />} />
        <Route path="/education" element={<Education />} />
        <Route path="/programs" element={<Education />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<Article />} />
        <Route path="/career" element={<Career />} />
        <Route path="/internship" element={<Internship />} />
        <Route path="/founder" element={<Founder />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="content" element={<ContentEditor />} />
          <Route path="team-services" element={<TeamServices />} />
          <Route path="submissions" element={<Submissions />} />
          <Route path="media" element={<Media />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <FloatingWhatsApp />}
      {!isAdmin && <ChatAssistant />}
      <Toaster position="bottom-right" />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <ContentProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </ContentProvider>
    </div>
  );
}

export default App;
